import React, { Component } from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

import CtaButtonSm from '../UI/CtaButtonSm'
import MobileMenu from './MobileMenu'
import { MdMenu } from 'react-icons/lib/md'
import NavLogo from '../Accessories/NavLogo'

const iconStyle = {
  width: '40px',
  height: '40px',
  color: 'black',
  background: 'white',
  border: '1px solid black',
  margin: '5px 0 0 5px',
  padding: '10px',
  borderRadius: '50%',
}

class TopNavigation extends Component {
  render() {
    return (
      <TopNavigationContainer>
        {/* Mobile Menu */}
        <div className="Mobile__MenuBar" style={{ position: 'relative' }}>
          <button onClick={() => this.mobileMenu.show()}>
            <MdMenu style={iconStyle} />
          </button>
          <MobileMenu
            ref={instance => {
              this.mobileMenu = instance
            }}
          />
        </div>
        <div className="Main__MenuBar TopNavigation__content-width">
          <LogoContainer>
            <Link to={'/'}>
              <NavLogo />
            </Link>
          </LogoContainer>
          <NavUl>
            <li>
              <Link to={'/'}>Home</Link>
            </li>
            <li>
              <Link to={'/pricing'}>Pricing</Link>
            </li>
            <li>
              <Link to={'/blog'}>Blog</Link>
            </li>
            <li>
              <Link to={'/customers'}>Customers</Link>
            </li>
            <li>
              <Link to={'/contact'}>Contact Us</Link>
            </li>
          </NavUl>
        </div>
      </TopNavigationContainer>
    )
  }
}

export default TopNavigation

const TopNavigationContainer = styled.div`
  //Layout
  width: 100vw;
  height: 100px;
  position: fixed;
  top: 0;
  z-index: 50;

  // Delight
  background: white;

  .TopNavigation__content-width {
    display: grid;
    grid-template-areas: 'logo navigation';
    grid-template-columns: 133px 1fr;
    margin: auto;
    width: 1200px;
  }

  @media screen and (max-width: 600px) {
    background: transparent;
  }

  .Mobile__MenuBar > button {
    position: relative;
    top: 10px;
    background: transparent !important;
    border: none !important;
  }

  @media screen and (max-width: 762px) {
    .Main__MenuBar {
      display: none;
    }
  }
  @media screen and (min-width: 762px) {
    .Mobile__MenuBar {
      display: none;
    }
  }
`

const LogoContainer = styled.div`
  grid-area: logo;
  align-self: center;
`

const NavUl = styled.ul`
  // Layout
  height: 100px;
  grid-area: navigation;
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(5, 100px);
  align-items: center;
  justify-content: end;

  // Delight
  list-style: none;

  li {
    text-align: center;
  }
  li > a {
    font-size: 1.6rem;
  }
`

// eslint-disable-next-line react/no-multi-comp
export class TopNavClear extends Component {
  render() {
    return <ClearContainer />
  }
}

const ClearContainer = styled.div`
  height: 100px;
`



// WEBPACK FOOTER //
// ./src/components/Layout/TopNavigation.jsx